module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I would like to dedicate this book to my grandmothers, Arlene and Lillian, and my grandfather, Sam. Special thanks to Mom, Dad, Grandpa Don (G-Money), Paul R. Kavieff, Mike Carone, Oscar Westerfield, Bill Randall, Bob Barenie, Joe Finnigan, Dave Parker, Adam Rafalski, Ty Spector (Jiggy), Mr. Green, Anna Wilson and Arcadia, Mary Wallace, Tom Featherstone and Wayne State, Ned Timmons, Richard Zuckerman, Norm Sinclair, Ian, Amy, Erin, David F., Sue, Neil Welch, Bobby B., Kathy, Jeremy, Jamie, Jake, Rachel, Tracey, Geri, David G., Stephanie, Sara, Morgan, Mac, Jeremy H., Eric, Judd, Rob, Andrew, Mikey, Rich, Eddie, John Binder, Ernie Righetti, Eric R., Byron, Laurie Evans, Nancy Webster, the Miller family, the Porter family, the Frank family, the Roeper family, the Glazek family, S. Owley, Jason, Dan, George Anastasia, the Butterscotch, the IU Nation, and the Detroit FBI office.")])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76063988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633106_ack01.vue
// module id = 72
// module chunks = 0